import '../styles/pages/legal.css'

function About() {
  return (
    <div className="legal-page">
      <div className="legal-content">
        <h1>Om platformen</h1>

        <section>
          <p style={{ fontSize: '1.1em', lineHeight: '1.8', fontStyle: 'italic', marginBottom: '24px' }}>
            Relationer er ikke svære, fordi mennesker vil hinanden ondt.<br />
            De er svære, fordi meget af det vigtigste aldrig bliver sagt højt.
          </p>
          
          <p style={{ lineHeight: '1.8' }}>
            Forventninger, behov, grænser, usikkerheder og ønsker lever ofte som tavs viden i os — og når de ikke bliver set eller mødt, bliver de til skuffelse, irritation, afstand eller konflikt. Ikke fordi nogen er forkerte, men fordi relationer mangler struktur nok til at kunne være trygge.
          </p>
          
          <p style={{ lineHeight: '1.8', fontWeight: '600', marginTop: '20px' }}>
            Denne platform er skabt for at give netop den struktur.
          </p>
          
          <p style={{ lineHeight: '1.8' }}>
            Ikke som terapi. Ikke som test. Ikke som en dom over hvem der har ret.<br />
            Men som en samling af små, gennemtænkte samtale- og refleksionsværktøjer, der hjælper mennesker med at forstå hinanden bedre — og handle klogere sammen.
          </p>
        </section>

        <section>
          <h2>Hvad er det?</h2>
          <p>
            Platformen er bygget op af moduler, der hver især adresserer et centralt område i relationer:
          </p>
          <ul>
            <li><strong>Forventninger</strong></li>
            <li><strong>Konflikter</strong></li>
            <li><strong>Følelsesmæssige behov</strong></li>
            <li><strong>Grænser</strong></li>
            <li><strong>Tillid og reparation</strong></li>
            <li><strong>Nærhed og intimitet</strong></li>
            <li><strong>Fælles retning og værdier</strong></li>
          </ul>
          <p>
            Hvert modul består af en række enkle udsagn og øvelser, som I svarer på hver for jer. Platformen viser derefter, hvor I matcher, og hvor I er forskellige — og guider jer videre med konkrete forslag til samtale, aftaler eller justeringer.
          </p>
          <p>
            Det tager typisk 10–20 minutter og kan gentages over tid.
          </p>
        </section>

        <section>
          <h2>Hvad bygger det på?</h2>
          <p>
            Modulerne er baseret på veldokumenterede psykologiske og terapeutiske tilgange, blandt andet:
          </p>
          <ul>
            <li><strong>Emotion Focused Therapy (EFT)</strong></li>
            <li><strong>Gottman-metoden</strong></li>
            <li><strong>Tilknytningsteori (Attachment Theory)</strong></li>
            <li><strong>Boundary Theory og assertiv kommunikation</strong></li>
            <li><strong>Modeller for tillidsopbygning og reparation</strong></li>
            <li><strong>Værdiafklaring og målpsykologi</strong></li>
          </ul>
          <p>
            Disse metoder er oversat fra klinisk praksis til et format, der er:
          </p>
          <ul>
            <li>let at bruge</li>
            <li>ikke-dømmende</li>
            <li>frivilligt</li>
            <li>og anvendeligt i hverdagen</li>
          </ul>
          <p style={{ marginTop: '16px', padding: '16px', background: 'rgba(102, 126, 234, 0.1)', borderRadius: '8px', border: '1px solid rgba(102, 126, 234, 0.3)' }}>
            <strong>Vigtigt:</strong> Platformen stiller ikke diagnoser og erstatter ikke professionel behandling. Den er et redskab til refleksion, dialog og fælles forståelse.
          </p>
        </section>

        <section>
          <h2>Hvorfor findes den?</h2>
          <p>
            Fordi mange relationer slides op — ikke af én stor konflikt — men af mange små ting, der aldrig bliver talt om.
          </p>
          <p>
            Fordi mennesker ofte først taler sammen, når de allerede er vrede, sårede eller opgivende.
          </p>
          <p>
            Og fordi det burde være lettere at:
          </p>
          <ul>
            <li>tale om svære ting uden at skade hinanden</li>
            <li>forstå forskelle uden at gøre dem til problemer</li>
            <li>og finde løsninger sammen i stedet for mod hinanden.</li>
          </ul>
          <p style={{ fontWeight: '600', marginTop: '16px' }}>
            Platformen er et forsøg på at gøre netop det lettere.
          </p>
        </section>

        <section>
          <h2>For hvem?</h2>
          <p>
            For mennesker der tager relationer alvorligt.
          </p>
          <p>
            Par, familier, venner, kollegaer og andre tætte relationer — uanset om I er i krise, i transition eller bare nysgerrige på at forstå hinanden bedre.
          </p>
          <p>
            For dem der ikke vil vente, til noget er gået i stykker, før de tager det op.
          </p>
        </section>

        <section>
          <h2>Værdier</h2>
          <p>
            Platformen bygger på nogle enkle principper:
          </p>
          <ul>
            <li><strong>Ingen er forkerte</strong> — der er kun forskelle</li>
            <li><strong>Forskelle er information, ikke trusler</strong></li>
            <li><strong>Struktur skaber tryghed</strong></li>
            <li><strong>Små justeringer over tid er mere bæredygtige end store løfter</strong></li>
            <li><strong>Frivillighed er vigtigere end pres</strong></li>
          </ul>
        </section>

        <section>
          <h2>Afslutning</h2>
          <p style={{ fontSize: '1.05em', lineHeight: '1.8' }}>
            Relationer kræver ikke perfektion.<br />
            De kræver opmærksomhed, ærlighed og struktur nok til at kunne være trygge.
          </p>
          <p style={{ fontSize: '1.05em', lineHeight: '1.8', marginTop: '16px' }}>
            Denne platform er et lille bidrag til netop det.
          </p>
          <p style={{ fontSize: '1.05em', lineHeight: '1.8', marginTop: '16px', fontStyle: 'italic' }}>
            Hvis den hjælper bare lidt med at gøre relationer klarere, roligere og mere menneskelige — så har den gjort sit arbejde.
          </p>
        </section>

        <section style={{ marginTop: '40px', paddingTop: '24px', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
          <h2>Kontakt</h2>
          <p>
            Har du spørgsmål, feedback eller forslag? Vi vil gerne høre fra dig!
          </p>
          <p>
            <strong>Email:</strong> <a href="mailto:info@thomasvalenzuela.com">info@thomasvalenzuela.com</a>
          </p>
        </section>
      </div>
    </div>
  )
}

export default About
